import script from "./Success.vue?vue&type=script&setup=true&lang=js"
export * from "./Success.vue?vue&type=script&setup=true&lang=js"

import "./Success.vue?vue&type=style&index=0&id=14bda14f&lang=less"
import "./Success.vue?vue&type=style&index=1&id=14bda14f&lang=less"

const __exports__ = script;

export default __exports__